module.exports = __webpack_public_path__ + "img/xydxxjs_bd.da2cbe7.png";